export const API_URL = "https://api.web3forms.com/submit";
export const ACCESS_KEY = "f67d7f82-1e54-4756-9d5b-4befbf4bc88d";
